import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";

class SearchFarmersStore extends EventEmitter {
    constructor() {
        super();
        this.allFarmers=[];
        this.myFarmers=[];

    }
    getAll() {
        return this.allFarmers;
    }
    getMyFarmers(){
        return this.myFarmers;
    }
    justEmit(){
        this.emit("change");
    }
    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_ALL_SEARCH_FARMERS":
            {
                this.allFarmers=[];
                this.allFarmers=action.searchFarmers;
                for(var i=0;i<this.allFarmers.length;i++){
                    var check=false;
                    var farmerCheck=this.allFarmers[i];
                    for(var j=0;j<this.myFarmers.length;j++){
                        var checkNow=this.myFarmers[j];
                        if(checkNow.id == farmerCheck.id){
                            farmerCheck["isMine"]=true;
                            check=true;
                            break;
                        }
                    }
                    if(check==false){
                        farmerCheck["isMine"]=false;
                    }
                }
                this.emit("change");
                break
            }
            case "CLEAR_SEARCH_FARMERS":{
                this.allFarmers=[];
                this.emit("change");
                break;
            }
            case "RECEIVE_MY_PREFERRED_FARMERS":{
                this.myFarmers=action.myFarmers;
                for(var i=0;i<this.myFarmers.length;i++){
                    this.myFarmers[i]["isMine"]=true;
                }
                this.emit("change");
                break;
            }
            case "ADD_TO_PREFERRED_FARMERS":{
                var farmer=action.farmer;
                farmer["isMine"]=true;
                this.myFarmers[this.myFarmers.length]=farmer;
                for(var i=0;i<this.allFarmers.length;i++){
                    var farmerCheck=this.allFarmers[i];
                    if(farmerCheck.id==farmer.id){
                        farmer["isMine"]=true;
                    }
                }
                this.emit("change");
            }
            case "REMOVE_FROM_PREFERRED_FARMERS":{
                var farmerId=action.farmerId;
                for(var i=0;i<this.allFarmers.length;i++){
                    var farmerCheck=this.allFarmers[i];
                    if(farmerCheck.id==farmerId){
                        farmerCheck["isMine"]=false;
                        break;
                    }
                }
                for(var i=0;i<this.myFarmers.length;i++){
                    var farmerCheck=this.myFarmers[i];
                    if(farmerCheck.id==farmerId){
                        this.myFarmers.splice(i,1);
                        break;
                    }
                }
                this.emit("change");
            }
        }



    }

}

const searchFarmers = new SearchFarmersStore;
dispatcher.register(searchFarmers.handleActions.bind(searchFarmers));

export default searchFarmers;



// WEBPACK FOOTER //
// ./src/stores/SearchFarmersStore.js